import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { FormGroup } from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIgetUsers } from '../../../api/User';

import UserSelectItem from '../../ModalUserSelectItem';
import SelectVirtualMenuList from '../../SelectVirtualMenuList';

const AdminReportsFilterUser = ({
  user,
  handleChange,
}) => {
  const intl = useIntl();

  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(true);

  const loadUsers = () => {
    setUsersLoading(true);

    APIgetUsers().then((response) => {
      const { data } = response;
      if (data) {
        setUsers(data);
      }
      setUsersLoading(false);
    });
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const getUsersOptions = () => {
    const options = [];

    users.forEach((u) => {
      options.push({
        uuid: u.uuid,
        email: u.email,
        name: u.name,
        avatar: u.avatar_url,
      });
    });

    return options;
  };

  return (
    <FormGroup className="report-user-filter-wrapper">
      <Select
        id="report-user-filter"
        className="user-select"
        classNamePrefix="user-select"
        name="reportUser"
        noOptionsMessage={() => ('No users')}
        getOptionValue={option => option.uuid}
        getOptionLabel={option => option.name}
        components={{
          Option: UserSelectItem,
          MenuList: SelectVirtualMenuList,
        }}
        placeholder={usersLoading ?
          intl.formatMessage({ defaultMessage: 'Loading...' }) :
          intl.formatMessage({ defaultMessage: 'Select user' })}
        isDisabled={usersLoading}
        isLoading={usersLoading}
        isClearable
        options={getUsersOptions()}
        onChange={handleChange}
        value={user}
        isOptionSelected={(option, value) => {
          if (value[0]) {
            return option.uuid === value[0].uuid;
          }
          return false;
        }}
      />
    </FormGroup>
  );
};

AdminReportsFilterUser.propTypes = {
  user: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};

AdminReportsFilterUser.defaultProps = {
  user: null,
};

export default AdminReportsFilterUser;
